import settings from '../../../config/settings'
import axios from '../api/axios'

export default class CippCalculatorApi {
  static submitCippCalculator(payload) {
    return axios.post(`${settings.apiBaseURL}/calculator`, payload)
  }
}
